import React, { useState, useEffect } from "react";
import { validateToken, callApi } from "../../../lib/utils";
import moment from "moment";
import { useSelector } from "react-redux";
import CustomLoader from "../../GenericComponents/CustomLoader";
import "./MedicationAdherence.css";
import store from "../../../reducers/store";
import GenericTableFilterBar from "../../GenericComponents/GenericTableFilterBar";
import MedicationAdherenceHeader from "./MedicationAdherenceHeader";
import MedicationAdherenceList from "./MedicationAdherenceList";
import "../DrillDownPage.css";


function MedicationAdherence() {
  const [medicationAdherenceList, setMedicationAdherenceList] = useState([]);
  const [searchList, setSearchList] = useState([]);
  const profileData = useSelector((state) => state?.dashboard);
  const [loading, setLoading] = useState(false);
  const currentPage = useSelector((state) => state?.tableFilter?.currentPage);
  const perPage = useSelector((state) => state?.tableFilter?.perPage);
  const startDate = useSelector((state) => state?.globalFilters?.startDate);
  const endDate = useSelector((state) => state?.globalFilters?.endDate);
  const pages = useSelector((state) => state?.appstate?.pages);

  useEffect(() => {
    if (profileData?.profileData?.id) {
      validateToken((err) => {
        if (err) {
          // console.log(err);
          window.location = "/logout";
        }
        fetchData();
      });
    }
  }, [perPage, currentPage]);

  const setPagination = (data) => {
    store.dispatch({ type: "SET_PAGINATION_PAGES", payload: { pages: data } });
  };

  const fetchData = () => {
    let params = {
      patientId: null,
      medicationId: null,
      start: startDate,
      end: endDate,
      page: currentPage,
      limit: parseInt(perPage),
      timezone: moment.tz.guess(),
    };
    setLoading(true);
    callApi(`/api/patient/med-reminder/list`, params, "POST")
      .then((response) => {
        setMedicationAdherenceList(response?.data?.data?.medReminderList);
        setSearchList(response?.data?.data?.medReminderList);
        setPagination(response?.data?.data?.pagination?.pages);
        setLoading(false);
      })
      .catch((err) => {
        console.log("err: ", err);
        setLoading(false);
      });
  };

  const filterRecordsBySearchText = (searchText) => {
    let filteredList = [];
    searchList.forEach((list) => {
      let shouldAdd = true;
      if (
        list.medicationName.toUpperCase().search(searchText.toUpperCase()) ===
        -1
      ) {
        shouldAdd = false;
      }

      if (shouldAdd) {
        filteredList.push(list);
      }
    });
    setMedicationAdherenceList(filteredList);
  };

  return (
    <div className="drilldown-page">
      <CustomLoader loading={loading} />

      <MedicationAdherenceHeader />
      <GenericTableFilterBar pages={pages} title="" filterRecordsBySearchText={filterRecordsBySearchText} />

      <MedicationAdherenceList currentPage={currentPage} perPage={perPage} medicationAdherenceList={medicationAdherenceList} />
    </div>
  );
}

export default MedicationAdherence;
